/* eslint-disable no-case-declarations */
import {
  ALGOS_HEALTH_STATUS,
  FETCH_SIGNAL_GROUP_ALGO_LIST_FAILURE,
  FETCH_SIGNAL_GROUP_ALGO_LIST_REQUEST,
  FETCH_SIGNAL_GROUP_ALGO_LIST_SUCCESS,
  SIGNAL_GROUP_ALGO_LIST_CACHE,
  SIGNAL_GROUP_ALGO_LIST_CLEAR,
  SIGNAL_GROUP_ALGO_LIST_UPDATE_DAY,
  SIGNAL_GROUP_ALGO_LIST_UPDATE_FILTERS,
  SIGNAL_GROUP_ALGO_LIST_UPDATE_LINKED_ALGOS,
  SIGNAL_GROUP_ALGO_SORTING,
  SIGNAL_GROUP_ALGOS_LIST_CHANGE,
  SIGNAL_GROUP_ALGOS_LIST_CONFIG_ERRORS_MODAL,
} from '../../../../../constants/ActionTypes';
import {
  updateSignalGroupAlgoDetails,
  updateSignalGroupAlgoHealthStatus,
  updateSignalsGroupLinkedAlgosData,
} from './updators';

const defaultData = () => {
  return {
    data: {},
    selectedDay: '',
    dataCached: [],
    filters: {},
    isFetching: false,
    error: null,
    updateTime: new Date(),
    cacheUpdateTime: new Date(),
    filtersUpdateTime: new Date(),
    sorting: {},
    modalErrors: {},
  };
};

const signalGroupAlgoList = (state = defaultData(), action) => {
  switch (action.type) {
    case FETCH_SIGNAL_GROUP_ALGO_LIST_REQUEST:
      return {
        ...state,
        data: {},
        dataCached: [],
        isFetching: true,
        error: null,
      };
    case FETCH_SIGNAL_GROUP_ALGO_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        data: action.data.data,
        updateTime: new Date(),
      };
    case FETCH_SIGNAL_GROUP_ALGO_LIST_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    case SIGNAL_GROUP_ALGO_LIST_CACHE:
      return { ...state, dataCached: action.data, cacheUpdateTime: new Date() };
    case SIGNAL_GROUP_ALGO_LIST_UPDATE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.data,
        },
        filtersUpdateTime: new Date(),
      };
    case SIGNAL_GROUP_ALGO_SORTING:
      return {
        ...state,
        sorting: action.data,
      };
    case SIGNAL_GROUP_ALGO_LIST_UPDATE_DAY:
      return {
        ...state,
        selectedDay: action.data,
      };
    case SIGNAL_GROUP_ALGO_LIST_UPDATE_LINKED_ALGOS:
      const dataChangeLinkedAlgos = updateSignalsGroupLinkedAlgosData(
        state,
        action.data
      );

      return {
        ...state,
        data: dataChangeLinkedAlgos,
        dataCached: dataChangeLinkedAlgos.data,
      };
    case SIGNAL_GROUP_ALGOS_LIST_CHANGE:
      const dataChangeCommon = updateSignalGroupAlgoDetails(
        state,
        action.algoId,
        action.updatedData
      );

      return {
        ...state,
        data: dataChangeCommon,
        dataCached: dataChangeCommon.data,
      };
    case SIGNAL_GROUP_ALGOS_LIST_CONFIG_ERRORS_MODAL:
      return {
        ...state,
        modalErrors: action.data,
      };
    case SIGNAL_GROUP_ALGO_LIST_CLEAR:
      return {
        ...state,
        ...defaultData(),
      };
    case ALGOS_HEALTH_STATUS:
      const dataChangeAlgoHealthStatus = updateSignalGroupAlgoHealthStatus(
        state,
        action?.data?.algos || []
      );

      return {
        ...state,
        data: dataChangeAlgoHealthStatus,
        dataCached: dataChangeAlgoHealthStatus.data,
      };
    default:
      return state;
  }
};

export default signalGroupAlgoList;
